import { generateActions } from '../../utils'
import { API_CONST } from '../../middlewares/api'
import { handleActions, createAction } from 'redux-actions'

const intiial = {
  items: {},
  categories: []
}

const getActions = generateActions('partners/list/GET')

export const getList = createAction(
  API_CONST,
  () => ({
    actions: getActions,
    url: 'partners'
  })
)

export default handleActions({
  [getActions[0]]: () => ({ ...intiial }),
  [getActions[1]]: (state, { payload = [] }) => {
    let items = {}
    let categories = payload.map(category => {
      category.items = category.items.map(el => {
        items[el._id] = el
        return el._id
      })
      return category
    })

    return ({ categories, items })
  }
}, intiial)



// WEBPACK FOOTER //
// ./src/store/reducers/partners/index.js